import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  id: string;
};

const fetchContractPDF = async ({ id }: Props) => {
  const response = await httpRequest.get(`/pdf/contracts/${id}`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `contract${id}.pdf`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useFetchContractPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchContractPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contracts"] });
    },
  });
}
